import _request from '@/utils/request.js'

var _channel = {
    // 根据渠道标识获取渠道信息
    getTabPage ( resolve, reject) {
        _request.api({
            url     : _request.getStaffsUrl("/api/channel/tabPage"),
            method  : 'post',
            success : resolve,
            error   : reject
        })
    },
    // 查询部门信息（树形结构）
    getDepartmentTree (query,resolve, reject) {
        _request.api({
            url     : _request.getStaffsUrl("/api/department/getDepartmentTree"),
            method  : 'get',
            params  : query,
            success : resolve,
            error   : reject
        })
    },
    // 根据渠道标识获取渠道信息
    getChannelInfo (query, resolve, reject) {
        _request.api({
            url     : _request.getStaffsUrl("/api/channel/info"),
            data  : query,
            method  : 'post',
            success : resolve,
            error   : reject
        })
    },
}

export default _channel